// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  spawnId: __t.u64().primaryKey().name("spawn_id"),
  worldId: __t.u64().name("world_id"),
  familyKey: __t.string().name("family_key"),
  cls: __t.string(),
  name: __t.string(),
  statsJson: __t.string().name("stats_json"),
  seed: __t.u32(),
  active: __t.bool(),
  spawnedAt: __t.timestamp().name("spawned_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
